document.addEventListener("DOMContentLoaded", () => {
    const popoverTriggerList = document.querySelectorAll("[data-bs-toggle=\"popover\"]");
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new window.bootstrap.Popover(popoverTriggerEl));
});
